import axiosInstance from "@/apis/axios-instance";
import {
  TreeViewResponse,
  UpdateAutoSumStateRequest,
  UpdateTransposeStateRequest,
} from "./types";

export const getTableTreeViewV2 = async (
  workbookId: string,
  tableId: string,
): Promise<TreeViewResponse> => {
  const response = await axiosInstance.get(
    `/v2/workbooks/${workbookId}/tables/${tableId}/tree-view`,
  );
  return response.data;
};

export const updateTransposeState = async (
  workbookId: string,
  tableId: string,
  request: UpdateTransposeStateRequest,
): Promise<void> => {
  await axiosInstance.patch(
    `/v2/workbooks/${workbookId}/tables/${tableId}/transpose-state`,
    {
      roleKey: request.roleKey,
      transpose: request.transpose,
    },
  );
};

export const updateAutoSumState = async (
  workbookId: string,
  tableId: string,
  request: UpdateAutoSumStateRequest,
): Promise<void> => {
  await axiosInstance.patch(
    `/v2/workbooks/${workbookId}/tables/${tableId}/auto-sum-state`,
    {
      roleKey: request.roleKey,
      useAutoSum: request.useAutoSum,
    },
  );
};
